import {bindable, customElement, inject} from "aurelia-framework";

@customElement('manual-price-link')
export class ManualPriceLink
{
  @bindable() params;
  url;

  attached()
  {
   
    if (this.params.data != null)
    {
      this.url =  'instrument/' + this.params.getValue() + '/4';
    }
  }


}


